var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedSquareBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5998 1.80078C14.588 1.80078 16.1998 3.41256 16.1998 5.40078V12.6008C16.1998 14.589 14.588 16.2008 12.5998 16.2008H5.3998C3.41158 16.2008 1.7998 14.589 1.7998 12.6008V5.40078C1.7998 3.41256 3.41158 1.80078 5.3998 1.80078H12.5998ZM12.2825 6.23223C11.9962 5.99362 11.5702 6.03215 11.3315 6.31836L8.05498 10.2506L6.32705 8.52354C6.06344 8.26008 5.63611 8.25998 5.37256 8.52354C5.10913 8.7871 5.10914 9.21446 5.37256 9.47803L8.14551 12.251L12.3687 7.1832C12.6073 6.89687 12.5687 6.47091 12.2825 6.23223Z",
    fill: "#FF7148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSquareBox);
export default __webpack_public_path__ + "static/media/checkedSquareBox.a51734fa5ea517cbcc2edfba157e15b6.svg";
export { ForwardRef as ReactComponent };